module.exports = __webpack_public_path__ + "img/smg.893d17a1.png";